import { useQuery } from "@tanstack/react-query";

import api from "@/common/utils/api";

import { orgQueryKeys } from "./orgQueryKeys";

export function useInviteData(orgId: string) {
  return useQuery({
    queryKey: orgQueryKeys.invite(orgId),

    queryFn: () =>
      api
        .get<"/orgs/:orgId/invite">(`/orgs/${orgId}/invite`)
        .then((res) => res.data.invite),
  });
}
